import { FC } from 'react'
import useJobCategoryStore from '../store/store.jobCategory'
import ContainerCategoryItem from './ContainerCategoryItem'

interface IFThirdCategoriesProps {
  className?: string
}

const ThirdCategories: FC<IFThirdCategoriesProps> = ({ className }) => {
  const jobCategoryStore = useJobCategoryStore()
  const { categories, idsByDepth, getCategoriesByIds, activeIds } =
    jobCategoryStore

  const selectedSecondCategoryId = activeIds[1]
  const selectedSecondCategory = selectedSecondCategoryId
    ? categories?.[selectedSecondCategoryId]
    : undefined

  const thirdDepthId = idsByDepth?.[3]
  const thirdCategories =
    (selectedSecondCategoryId &&
      thirdDepthId &&
      getCategoriesByIds(thirdDepthId).filter(
        (category) => category.parentId === selectedSecondCategoryId,
      )) ||
    []

  return (
    <ContainerCategoryItem
      categories={thirdCategories}
      parentCategory={selectedSecondCategory}
      className={className}
    />
  )
}

export default ThirdCategories
